import { render, staticRenderFns } from "./fixBrand.vue?vue&type=template&id=3f916874&scoped=true&"
import script from "./fixBrand.vue?vue&type=script&lang=js&"
export * from "./fixBrand.vue?vue&type=script&lang=js&"
import style0 from "./fixBrand.vue?vue&type=style&index=0&id=3f916874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f916874",
  null
  
)

export default component.exports